import { z } from 'zod'

import { MarketingType } from '../constants/marketing'
import {
  marketingAdminSegmentDefinitionSchema,
  marketingOrganizationSegmentDefinitionSchema,
} from './marketingSegmentDefinition'
import { marketingEntityScopeSchema } from './marketingScope'
import { dbEntitySchema } from './system'

export const marketingSegmentDefinitionSchema = z.union([
  marketingAdminSegmentDefinitionSchema,
  marketingOrganizationSegmentDefinitionSchema,
])

const marketingSegmentFieldsSchema = z.object({
  name: z.string(),
  definition: marketingSegmentDefinitionSchema,
})

export const marketingSegmentSchema = dbEntitySchema
  .and(marketingEntityScopeSchema)
  .and(marketingSegmentFieldsSchema)
  .superRefine((data, ctx) => {
    if (data.type === MarketingType.ADMIN) {
      const parsed = marketingAdminSegmentDefinitionSchema.safeParse(
        data.definition
      )
      if (parsed.success) return
      for (const issue of parsed.error.issues) {
        ctx.addIssue({
          ...issue,
          path: ['definition', ...issue.path],
        })
      }
      return
    }

    const parsed = marketingOrganizationSegmentDefinitionSchema.safeParse(
      data.definition
    )
    if (parsed.success) return
    for (const issue of parsed.error.issues) {
      ctx.addIssue({
        ...issue,
        path: ['definition', ...issue.path],
      })
    }
  })

export const marketingSegmentPreviewArgsSchema = marketingEntityScopeSchema
  .and(
    z.object({
      definition: marketingSegmentDefinitionSchema,
    })
  )
  .superRefine((data, ctx) => {
    if (data.type === MarketingType.ADMIN) {
      const parsed = marketingAdminSegmentDefinitionSchema.safeParse(
        data.definition
      )
      if (parsed.success) return
      for (const issue of parsed.error.issues) {
        ctx.addIssue({
          ...issue,
          path: ['definition', ...issue.path],
        })
      }
      return
    }

    const parsed = marketingOrganizationSegmentDefinitionSchema.safeParse(
      data.definition
    )
    if (parsed.success) return
    for (const issue of parsed.error.issues) {
      ctx.addIssue({
        ...issue,
        path: ['definition', ...issue.path],
      })
    }
  })

export const marketingSegmentPreviewResponseSchema = z.object({
  estimatedCount: z.number(),
})

export const marketingSegmentCreateArgsSchema = marketingEntityScopeSchema
  .and(marketingSegmentFieldsSchema)
  .superRefine((data, ctx) => {
    if (data.type === MarketingType.ADMIN) {
      const parsed = marketingAdminSegmentDefinitionSchema.safeParse(
        data.definition
      )
      if (parsed.success) return
      for (const issue of parsed.error.issues) {
        ctx.addIssue({
          ...issue,
          path: ['definition', ...issue.path],
        })
      }
      return
    }

    const parsed = marketingOrganizationSegmentDefinitionSchema.safeParse(
      data.definition
    )
    if (parsed.success) return
    for (const issue of parsed.error.issues) {
      ctx.addIssue({
        ...issue,
        path: ['definition', ...issue.path],
      })
    }
  })

export const marketingSegmentUpdateArgsSchema = z.object({
  name: z.string().optional(),
  definition: marketingSegmentDefinitionSchema.optional(),
})
